import type {Component} from 'panel';

import type {Store, SubscriptionCallback} from 'common/report/stores/store';

export function useEventListener(
  component: Component<unknown>,
  target: EventTarget,
  event: string,
  listener: EventListenerOrEventListenerObject,
  listenerOptions?: AddEventListenerOptions,
) {
  target.addEventListener(event, listener, listenerOptions);
  component.onDisconnected(() => target.removeEventListener(event, listener, listenerOptions));
}

/**
 * Provides component integration for a particular store by adding
 * a subscriber that forces an update on the component by default
 * or invokes subscriptionCallback if passed; this subscription
 * is removed when the component is unmounted
 *
 * @param component
 * @param store
 * @param subscriptionCallback
 */
export function useStore<StoreValueT>(
  // TODO: this should be of the type `Component<unknown>`, but app components that use JSURLMixin mangles the type, needs to be fixed
  component: TODO,
  store: Store<StoreValueT>,
  subscriptionCallback?: SubscriptionCallback,
): Store<StoreValueT> {
  if (!subscriptionCallback) {
    subscriptionCallback = component.update.bind(component);
  }
  store.subscribe(subscriptionCallback);
  component.onDisconnected(() => store.unsubscribe(subscriptionCallback));
  return store;
}
